
export default {
  components: {
  },
  // inject: ['detail'],
  props: {
    softval: {
      type: Object,
      default: () => {}
    },
    main: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      imgArr: [],
      mImgArr:[],
      imgIndex: 0,
      ece2: -1,
      detail: {},
      listCount: 5,
      bigimgShow: false,
      iosArr:[],
      winArr:[],
      type:1 // 1为ctrade 2为wtrade
    }
  },
  watch:{
    show(v){
      if (v) {
        document.body.style.setProperty('overflow', 'hidden', 'important')
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    wapShow() {
      return this.$store.state.mobile
    }
  },
  mounted() {
    if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
      this.listCount = 4
    } else {
      this.listCount = 5
    }
    window.addEventListener('resize', () => {
      if (document && document.documentElement && document.documentElement.clientWidth <= 999) {
        this.listCount = 4
      } else {
        this.listCount = 5
      }
    })
    const that = this
    document.addEventListener('keydown', function (e) {
      if (e.keyCode == 27) {
        that.bigimgShow = false
      }
    })
    // console.log(this.wapShow, 'wapShow1111');
    console.log(this.softval, 'softval222')
  },
  methods: {
    linkcompany(i){
      if(i.companyId) window.open(`/${this.$store.state.LanguageCode}/company/${i.companyId}.html`)
    },
    linkdown(i){
      console.log('i: ', i);
      if(!i.isCopy) window.open(i.url)
    },
    open(i=1) {
      console.log('this.$parent.detail',this.main);
      
      this.type = i
      // 打开弹框
      this.imgArr = []
      this.imgIndex = 0
      this.ece2 = -1
      this.getDetail(i)
    },
    close() {
      // 关闭弹框
      document.body.style.overflow = 'auto'
       this.winArr = []
       this.iosArr = []
       this.imgArr = []
       this.mImgArr =[]
      this.imgIndex = 0
      this.show = false
    },
    getDetail(i=1) {
      if(i == 1){
         // 获取相关软件详情页
          this.$api.common.CV3(
          {
            softwareId: this.softval.softwareId,
            companyId: this.main.main.companyId
          },
          {
            Routes: 'wikifxagg$softwate_get_trader_retelated_ctrader_software_detail'
          }).then((data) => {
              const res = data?.wikifxagg?.softwate_get_trader_retelated_ctrader_software_detail?.data
              console.log('res: 111', res);
              for (const key in res) {
                this.$set(this.detail, key, res[key])
              }
              res.downloads.forEach((item)=>{
                if(item.isCopy) this.winArr.push(item)
                else this.iosArr.push(item)
              })

              this.imgArr = [...res.webPreviewImages]
              this.mImgArr = [...res.previewImages]
              document.body.style.overflow = 'hidden'
              this.show = true
              // this.$nextTick(() => {
              //   const mt = document.getElementById('mt-t-list-p')
              //   if (mt) { 
              //     mt.style.transform = 'translateX(0)'
              //   }

              //   this.setimg(res.images[0])
              // })
            })
      }else if(i == 2){
        // 获取相关软件详情页
          this.$api.common.CV3(
          {
            softwareId: this.softval.softwareId,
            traderCode: this.main.main.traderCode
          },
          {
            Routes: 'wikifxagg$trader_retelated_wtrader_software_detail'
          }).then((data) => {
              const res = data?.wikifxagg?.trader_retelated_wtrader_software_detail?.data
              console.log('res: 111', res);
              for (const key in res) {
                this.$set(this.detail, key, res[key])
              }
              res.downloads.forEach((item)=>{
                if(item.isCopy) this.winArr.push(item)
                else this.iosArr.push(item)
              })

              this.imgArr = [...res.webPreviewImages]
              this.mImgArr = [...res.previewImages]
              document.body.style.overflow = 'hidden'
              this.show = true
              // this.$nextTick(() => {
              //   const mt = document.getElementById('mt-t-list-p')
              //   if (mt) { 
              //     mt.style.transform = 'translateX(0)'
              //   }

              //   this.setimg(res.images[0])
              // })
            })
          }
      
    },
    setimg(img) {
      const softImg = document.getElementById('softImg')
      const ig = new Image()
      ig.src = img
      ig.onload = () => {
        if (softImg) {
          const width = ig.width
          if (width >= 696) {
            softImg.style.width = '100%'
          } else {
            softImg.style.width = 'auto'
            softImg.style['max-width'] = '100%'
          }
        }
      }
    },
    fuzhi(val) {
      // 复制文本
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$v('复制成功'),
        type: 'success'
      })
      document.body.removeChild(input)
    },
  }
}
